module.exports = __webpack_public_path__ + "img/timing-box-dark-en.df9c1809.png";